import {Component, OnDestroy, OnInit} from '@angular/core';
import {OrdineGroup} from '../../../_models/OrdineGroup';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {MovimentiService} from '../../../_services/movimenti.service';
import {SaveMessage} from '../../../_helpers/save-message';
import {AuthenticationService} from '../../../_services/authentication.service';
import {ModalController} from '@ionic/angular';
import {constants} from '../../../_helpers/constants';
import {Movimento} from '../../../_models/Movimento';
import {AvanzamentoService} from '../../../_services/avanzamento.service';
import {OrdineEsolver} from '../../../_models/OrdineEsolver';
import {LocalService} from '../../../_services/local.service';
import {Ordine} from '../../../_models/Ordine';
import {FilterItem} from '../../../_models/FilterItem';
import {OrdineByBarcode} from '../../../_models/OrdineByBarcode';
import {Subscription} from 'rxjs';
import {Organizzazione} from '../../../_models/Organizzazione';
import {Contenitore} from '../../../_models/Contenitore';
import {LicenzeService} from '../../../_services/licenze.service';
import {MessageConfirm} from '../../../_helpers/message-confirm.service';
import {ArticoliService} from '../../../_services/articoli.service';

@Component({
    selector: 'app-movimento-trasferimento',
    templateUrl: './movimento-trasferimento.component.html',
    styleUrls: ['./movimento-trasferimento.component.scss'],
    standalone: false
})
export class MovimentoTrasferimentoComponent  implements OnInit, OnDestroy {
  ordine: OrdineGroup;
  movimenti: Movimento[] = [];
  codArt = '';
  udM = '';
  udM2 = '';
  fromAvanzamento = false;
  quantitaTotale = 0;
  useMagScarico = false;
  magazzinoScarico = '';
  magAreaScarico = '';
  magazzinoTraferimento = '';
  magAreaTrasferimento = '';
  generaDdt = false;
  codCliFor = 0;
  indirizzoNumProg = -1;
  codBox = '';
  loading = false;
  subscriptions: Subscription;
  protected readonly constants = constants;
  constructor(
    public authService: AuthenticationService,
    public licenseService: LicenzeService,
    private localService: LocalService,
    private avanzamentoService: AvanzamentoService,
    private organizzazioneService: OrganizzazioniService,
    private movimentiService: MovimentiService,
    private articoliService: ArticoliService,
    private saveMessage: SaveMessage,
    private messageConfirm: MessageConfirm,
    private modalCtrl: ModalController) { }

  ngOnInit() {
    if (this.ordine && this.ordine.ordini) {
      this.selOrdine(this.ordine.ordini[0]);
      this.codArt = this.ordine.codiceArticolo;
      this.udM = this.ordine.udM;
      this.udM2 = this.ordine.udM2;
    }
    if (this.fromAvanzamento) {
      this.useMagScarico = true;
      this.magazzinoScarico = this.ordine.codMagPrincipale;
      this.magAreaScarico = this.ordine.codAreaMagPrinc;
    }
    this.subscriptions = this.localService.searchText.subscribe((_search: string) => {
      if (_search == null || _search.length === 0) {
        return false;
      }
      // Check valid barcode
      const regex9 = /^[0-9]{9}$/gm;
      const regex13 = /^[0-9]{13}$/gm;
      const regex17 = /^[0-9]{17}$/gm;
      if (regex9.test(_search) ||regex13.test(_search) || regex17.test(_search)) {
        this.searchByBarcode(_search)
          .catch(() => this.saveMessage.messageError("Ci sono problemi con il codice a barre dell'ordine."));
      }
    });
    this.codCliFor = this.organizzazioneService.currentOrganizzazioneValue.codCliForEsolver;
    this.subscriptions.add(this.organizzazioneService.currentOrganizzazione
      .subscribe((_organizzazione: Organizzazione) => {
        this.codCliFor = _organizzazione.codCliForEsolver;
      }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  selContenitore = async (giacenza: Contenitore) => {
    if (this.movimenti.some(m => m.codBox === giacenza.codice))
      return false;
    if (!giacenza.codArt) {
      this.saveMessage.messageError("Contenitore non valido: nessun articolo.");
      return false;
    }
    const dataEvento = Math.floor(new Date().getTime() / 1000);
    if (!giacenza.magUdM) {
      giacenza.magUdM = giacenza.udM;
    }
    const qtaMagUdM = giacenza.magUdM === giacenza.udM ?
      giacenza.giacenza : giacenza.giacenzaUdM2;
    const qtaMagUdM2 = giacenza.magUdM === giacenza.udM2 ?
      giacenza.giacenza : giacenza.giacenzaUdM2;
    const movimento: Movimento = {
      organizzazioneId: this.organizzazioneService.organizzazioneId,
      id: 0,
      dataUnixRegistrazione: dataEvento,
      rifOdP: giacenza.rifOdP,
      idRigaMateriale: 0,
      codArt: giacenza.codArt,
      unitaMisura: giacenza.magUdM,
      udM2: giacenza.udM === giacenza.magUdM ?  giacenza.udM2 : giacenza.udM,
      magUdM: giacenza.magUdM,
      quantita: qtaMagUdM,
      quantitaUdM2: qtaMagUdM2,
      coeffX1: 1,
      codLottoAlfa: giacenza.codLottoAlfa,
      codBox: giacenza.codice,
      contesto: 3,
      tipoMovimento: 1,
      tipoQuantita: giacenza.tipoBox,
      idAnagrafica: this.codCliFor,
      codMagazzinoIn: this.magazzinoTraferimento,
      codMagAreaIn: this.magAreaTrasferimento,
      codMagazzinoOut: this.useMagScarico ? this.magazzinoScarico : giacenza.codMagazzino,
      codMagAreaOut: this.useMagScarico ? this.magAreaScarico : giacenza.codMagArea
    };
    movimento.giacPerLotti = await this.loadGiacPerLotti(movimento.codArt);
    // FR-013: ri-verifica la guardia anti-duplicato DOPO l'await (selContenitore è async).
    // Chiude la race su doppio fire dello scanner dello stesso codBox. Deduplica solo per codBox:
    // lo stesso codArt in codBox diversi DEVE poter generare più righe.
    if (this.movimenti.some(m => m.codBox === giacenza.codice))
      return false;
    this.movimenti = [...this.movimenti, movimento];
    //this.movimenti.push(movimento);
  };

  // Recupera il flag di gestione lotti dell'articolo (anagrafica ESOLVER). La memoizzazione sta ora
  // in ArticoliService, condivisa con gli altri punti che leggono lo stesso articolo e con la
  // chiave che include l'organizzazione — quella locale la ignorava. In errore ritorna undefined
  // senza propagare nulla (fail-open), come prima.
  private loadGiacPerLotti = async (codArt: string): Promise<number | undefined> => {
    try {
      const art = await this.articoliService.getArticoloEsolverByCodArt(
        this.organizzazioneService.organizzazioneId, codArt);
      return typeof art?.giacPerLotti === 'number' ? art.giacPerLotti : undefined;
    } catch {
      return undefined;
    }
  };

  async searchByBarcode(barCode: string) {
    this.loading = true;
    const filters: FilterItem[] = [
      { fieldName:'RifOrdine', operazione: 1, value1: barCode,value2:'', tipoFormControl: null, showColumn: false }
    ];
    this.avanzamentoService
      .getOrdiniByBarcode(this.organizzazioneService.organizzazioneId, false, filters, this.organizzazioneService.filtroOrdini)
      .then((_ordini: OrdineByBarcode) => {
        if (_ordini.ordini != null && _ordini.ordini.length > 0) {
          const ordineGroup: OrdineGroup = {..._ordini.ordini[0], ordini: [_ordini.ordini[0]], avvioType: 0 };
          this.ordine = ordineGroup;
          this.selOrdine(_ordini.ordini[0]);
        }
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dell'ordine."))
      .finally(() => this.loading = false);
  }
  
  selOrdine = async (ordine: Ordine) => {
    const dataEvento = Math.floor(new Date().getTime() / 1000);
    const movimento: Movimento = {
      organizzazioneId: this.organizzazioneService.organizzazioneId,
      id: 0,
      dataUnixRegistrazione: dataEvento,
      rifOdP: ordine.rifOdP,
      numFase: ordine.numFase,
      idRigaMateriale: ordine.idRiga,
      codArt: ordine.codiceArticolo,
      unitaMisura: ordine.udM,
      udM2: ordine.udM2,
      magUdM: ordine.udM,
      quantita: ordine.quantitaLavorata + ordine.quantitaScartata + ordine.quantitaNonConforme,
      quantitaUdM2: ordine.quantitaLavorataUdM2 + ordine.quantitaScartataUdM2 + ordine.quantitaNonConformeUdM2,
      coeffX1: 1,
      codLottoAlfa: ordine.rifLottoProdotto,
      //codBox: ordine.codice,
      contesto: 3,
      tipoMovimento: 1,
      idAnagrafica: this.codCliFor,
      codMagazzinoIn: this.magazzinoTraferimento,
      codMagAreaIn: this.magAreaTrasferimento,
      codMagazzinoOut: this.useMagScarico ? this.magazzinoScarico : ordine.codMagPrincipale,
      codMagAreaOut: this.useMagScarico ? this.magAreaScarico : ordine.codAreaMagPrinc
    };
    movimento.giacPerLotti = await this.loadGiacPerLotti(movimento.codArt);
    this.movimenti.push(movimento);
  };

  setMagazzino = (nextOrdine: OrdineEsolver, backNext: number) => {
    if (nextOrdine && nextOrdine.risorsaLocale && backNext >= 0) {
      this.magazzinoTraferimento = nextOrdine.risorsaLocale.codMagazzino;
      this.magAreaTrasferimento = nextOrdine.risorsaLocale.codMagArea;
    }
    if (nextOrdine && nextOrdine.risorsaLocale && backNext < 0) {
      this.magazzinoScarico = nextOrdine.risorsaLocale.codMagazzino;
      this.magAreaScarico = nextOrdine.risorsaLocale.codMagArea;
    }
  };
  confirm = () => {
    if (this.movimenti.length === 0) return;
    this.messageConfirm.presentCustomAlert(
      'Conferma trasferimento',
      `Confermi il trasferimento di ${this.movimenti.length} articol${this.movimenti.length === 1 ? 'o' : 'i'}?`,
      'TRASFERISCI', 'success',
      () => {
        const dataEvento = Math.floor(new Date().getTime() / 1000);
        this.createMovimenti(dataEvento);
        this.movimenti = [];
        this.codBox = '';
        this.generaDdt = false;
        this.magazzinoScarico = '';
        this.magAreaScarico = '';
        this.magazzinoTraferimento = '';
        this.magAreaTrasferimento = '';
      }
    );
  };
  cancel = () => this.modalCtrl.dismiss(false, 'cancel');

  createMovimenti = (dataEvento: number) => {
    this.movimenti.forEach((_movimento: Movimento) => {
      _movimento.dataUnixRegistrazione = dataEvento;
      _movimento.codMagazzinoOut = this.useMagScarico ? this.magazzinoScarico : _movimento.codMagazzinoOut;
      _movimento.codMagAreaOut = this.useMagScarico ? this.magAreaScarico : _movimento.codMagAreaOut;
      _movimento.codMagazzinoIn = this.magazzinoTraferimento;
      _movimento.codMagAreaIn = this.magAreaTrasferimento;
      _movimento.idAnagrafica = this.codCliFor;
      _movimento.idIndrizzoSped = this.indirizzoNumProg;
      this.movimentiService.createMovimentoAsync(_movimento)
        .catch(() => this.saveMessage
          .messageError(`Ci sono problemi con la creazione del movimento ${_movimento.codArt}.`));
    });
    if (this.generaDdt) {
      this.movimentiService.ddtTrasferimentoInternoAsync(this.organizzazioneService.organizzazioneId,
        constants.DDTMES, this.movimenti)
        .then(() => this.saveMessage.messageInfo('Richiesta DDT inviata con successo.'))
        .catch(() => this.saveMessage
          .messageError(`Ci sono problemi con la creazione del DDT.`));
    }
  };

  removeMateriale = (materiale: Movimento) =>
    this.movimenti = this.movimenti.filter((_mov: Movimento) => _mov !== materiale);

  get hasMovimentiNonValidi(): boolean {
    return this.movimenti.some(m => m.quantita <= 0);
  }
}
